import React, { useEffect, useState } from "react";
import { Layout, Menu, Button, Drawer, Grid } from "antd";
import { items } from "utils/SignInUpData";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
const { Header } = Layout;

const HEADER_LINK_TEXT = process.env.REACT_APP_HEADER_LINK_TEXT || "iSekurex Capital";
const HEADER_LINK_TO = process.env.REACT_APP_HEADER_LINK_TO || "/";
const HEADER_LOGO_URL = process.env.REACT_APP_HEADER_LOGO_URL || "";

const AntdHeader = ({ btn }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const screens = Grid.useBreakpoint();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const headerStyle = {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    paddingLeft: "max(16px, env(safe-area-inset-left))",
    paddingRight: "max(16px, env(safe-area-inset-right))",
    backdropFilter: scrolled ? "saturate(1.1) blur(8px)" : "saturate(1.05) blur(0px)",
    WebkitBackdropFilter: scrolled ? "saturate(1.1) blur(8px)" : "saturate(1.05) blur(0px)",
    background: scrolled
      ? "linear-gradient(180deg, rgba(2,6,23,0.90), rgba(2,6,23,0.78)), radial-gradient(120% 160% at -10% -20%, rgba(253,224,71,0.10), transparent 60%), radial-gradient(140% 180% at 110% -30%, rgba(251,191,36,0.08), transparent 60%)"
      : "linear-gradient(180deg, rgba(2,6,23,0.55), rgba(2,6,23,0.25)), radial-gradient(120% 160% at -10% -20%, rgba(253,224,71,0.08), transparent 60%), radial-gradient(140% 180% at 110% -30%, rgba(251,191,36,0.06), transparent 60%)",
    borderBottom: scrolled ? "1px solid rgba(253,224,71,0.24)" : "1px solid rgba(148,163,184,0.12)",
  };

  const brandStyle = {
    margin: 0,
    fontWeight: 700,
    letterSpacing: "0.2px",
    fontSize: "clamp(14px, 2.1vw, 18px)",
    lineHeight: 1.2,
    backgroundImage:
      "linear-gradient(92deg, #f8fafc 0%, #fde68a 22%, #fbbf24 44%, #fde68a 66%, #f8fafc 100%)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    color: "transparent",
    textRendering: "optimizeLegibility",
    marginLeft: 0,
    backgroundSize: "200% 100%",
    backgroundPosition: "0% 0%",
    filter: "drop-shadow(0 1px 0 rgba(255,255,255,0.12)) drop-shadow(0 2px 6px rgba(251,191,36,0.22))",
    transition: "background-position .6s ease, filter .3s ease",
  };

  const brandMarkStyle = {
    width: 18,
    height: 18,
    borderRadius: "50%",
    background:
      "radial-gradient(120% 120% at 20% 20%, rgba(253,224,71,0.95), rgba(251,191,36,0.55) 40%, rgba(146,114,52,0.22) 68%, rgba(0,0,0,0) 72%), linear-gradient(180deg, rgba(255,255,255,0.28), rgba(255,255,255,0))",
    boxShadow:
      "inset 0 1px 1px rgba(255,255,255,0.6), 0 0 0 1px rgba(251,191,36,0.32), 0 8px 20px rgba(251,191,36,0.12)",
    flex: "0 0 18px",
  };

  return (
    <Header style={headerStyle} className="appverse-header">
      <div className="header-col header-brand" style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {/* subtle sheen on brand text via background-position shift */}
        <style>{`
    /* — Luxe hover micro‑interactions (gold theme) — */
    .appverse-header .brand-name{background-size:200% 100%; position:relative; display:inline-block;}
    .appverse-header .brand-name:hover{background-position:100% 0; filter:saturate(1.06) brightness(1.03);}    
    .appverse-header .brand-name::after{
      content:""; position:absolute; inset:0 auto 0 -160%;
      width:60%; pointer-events:none;
      background: linear-gradient(115deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.28) 46%, rgba(255,255,255,0) 100%);
      transform: skewX(-18deg);
      transition: left 1.1s ease, opacity 1.1s ease;
      opacity: .0;
    }
    .appverse-header .brand-name:hover::after{ left:160%; opacity:.95; }

    .appverse-header .brand-mark{ transition: transform .25s ease, box-shadow .25s ease, filter .25s ease; }
    .appverse-header .header-brand:hover .brand-mark{ transform: translateY(-1px) scale(1.06); filter:saturate(1.06); box-shadow: inset 0 1px 1px rgba(255,255,255,0.65), 0 0 0 1px rgba(251,191,36,0.38), 0 10px 24px rgba(251,191,36,0.16); }

    .appverse-header .appverse-nav.ant-menu-horizontal{ background:transparent; border:none; }
    .appverse-header .appverse-nav .ant-menu-item{ border-radius:10px; transition: transform .18s ease, box-shadow .18s ease, background .18s ease, filter .18s ease; }
    .appverse-header .appverse-nav .ant-menu-item:hover{ transform: translateY(-1px); filter:saturate(1.04); background: linear-gradient(180deg, rgba(253,224,71,0.10), rgba(253,224,71,0.03)); box-shadow: inset 0 0 0 1px rgba(251,191,36,0.28), 0 6px 14px rgba(251,191,36,0.12); }

    .appverse-header .header-actions .ant-btn{ transition: filter .18s ease, box-shadow .18s ease, transform .18s ease; }
    .appverse-header .header-actions .ant-btn:hover{ transform: translateY(-1px); filter: saturate(1.05) brightness(1.04); box-shadow: 0 6px 14px rgba(251,191,36,0.18); }
  `}</style>
        <Link to={HEADER_LINK_TO} aria-label={HEADER_LINK_TEXT} style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          {HEADER_LOGO_URL ? (
            <img src={HEADER_LOGO_URL} alt="Logo" style={{ width: 18, height: 18, borderRadius: 4, objectFit: "contain" }} />
          ) : (
            <span className="brand-mark" style={brandMarkStyle} />
          )}
          <h5 style={brandStyle} className="brand-name">{HEADER_LINK_TEXT}</h5>
        </Link>
      </div>

      {/* Desktop nav */}
      {screens.md ? (
        <div className="header-col header-nav" style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
          <Menu
            className="appverse-nav"
            defaultSelectedKeys={["1"]}
            mode="horizontal"
            items={items}
            style={{
              display: "flex",
              gap: 8,
              border: "none",
              background: "transparent",
              alignItems: "center",
            }}
          />
        </div>
      ) : (
        // Mobile: show a menu button that opens a Drawer
        <div className="header-col header-actions" style={{ marginLeft: "auto" }}>
          <Button
            type="text"
            aria-label="Open navigation menu"
            icon={<MenuOutlined />}
            onClick={() => setOpen(true)}
          />
          <Drawer
            title={HEADER_LINK_TEXT}
            placement="right"
            closable
            onClose={() => setOpen(false)}
            open={open}
            bodyStyle={{ padding: 0 }}
          >
            <Menu
              className="appverse-nav"
              mode="inline"
              items={items}
              onClick={() => setOpen(false)}
              style={{ borderInlineEnd: 0 }}
            />
          </Drawer>
        </div>
      )}
    </Header>
  );
};
export default AntdHeader;
